import { SimpleChanges } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';

export class AbmChangeFilter {
    constructor(private _changes: SimpleChanges) { }

    static of(changes: SimpleChanges) {
        return new AbmChangeFilter(changes);
    }

    notEmpty<T>(key: string): Observable<T> {
        if (this._changes[key]) {
            const value: T = this._changes[key].currentValue;

            if (value !== undefined && value !== null) {
                return of(value);
            }
        }
        return EMPTY;
    }

    has<T>(key: string): Observable<T> {
        if (this._changes[key]) {
            const value: T = this._changes[key].currentValue;
            return of(value);
        }
        return EMPTY;
    }

    notFirst<T>(key: string): Observable<T> {
        if (this._changes[key] && !this._changes[key].isFirstChange()) {
            const value: T = this._changes[key].currentValue;
            return of(value);
        }
        return EMPTY;
    }

    notFirstNorEmpty<T>(key: string): Observable<T> {
        if (this._changes[key] && !this._changes[key].isFirstChange()) {
            const value: T = this._changes[key].currentValue;

            if (value !== undefined && value !== null) {
                return of(value);
            }
        }
        return EMPTY;
    }

    notFirstButEmpty(key: string): Observable<true> {
        if (this._changes[key] && !this._changes[key].isFirstChange()) {
            const value = this._changes[key].currentValue;

            if (value === undefined || value === null) {
                return of(true);
            }
        }
        return EMPTY;
    }

    isFirst<T>(key: string): Observable<T> {
        if (this._changes[key] &&
            this._changes[key].isFirstChange() &&
            this._changes[key].currentValue) {
            return of(this._changes[key].currentValue);
        }

        return EMPTY;
    }
}
